import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from '../tooltip/tooltip.module';
import { IconModule } from '../icon/icon.module';
import { InputComponent } from './input.component';
import { ButtonComponent } from '../button/button.component';

@NgModule({
	declarations: [InputComponent],
	exports: [InputComponent],
	imports: [CommonModule, IconModule, TooltipModule, ButtonComponent],
})
export class InputModule {}
